import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { AcceptedFile } from './elements/AcceptedFile'
import { useMediaListService } from './MediaList.service'

const MediaList = ({ media, fileToReplace, onRemove, onRemoveGroup, isMobileSize, onAddFileToGroup, onReplaceFileInGroup, onValidationError, hasMediaPlacementError, ...otherProps }) => {
  const { 
    getGroupedMedia,
    handleFileSelect,
    getDisplayFile,
  } = useMediaListService({ media, onReplaceFileInGroup, onAddFileToGroup, onValidationError })

  const cn = classnames({
    'media-files': true,
    'mobile-view': isMobileSize,
  })

  if (media.length) {
    const groupedMedia = getGroupedMedia()

    return (
      <>
        <div className={cn}>
          {groupedMedia.map((item) => {
            const { displayFile, uploadingFile } = getDisplayFile(item, fileToReplace)

            return (
              <AcceptedFile
                key={item.groupId ? `group-${item.groupId}` : displayFile.id}
                file={displayFile}
                uploadingFile={uploadingFile}
                onRemove={() => {
                  // If it's a group, remove all files in the group
                  if (item.groupId && onRemoveGroup) {
                    onRemoveGroup(item.groupId)
                  } else if (!item.groupId) {
                    // Single file, just remove it
                    onRemove(displayFile.id)
                  }
                }}
                onClick={() => {
                  // Pass group info
                  otherProps.setExpandedImage({
                    ...displayFile,
                    groupId: item.groupId,
                    feedFile: item.feedFile,
                    reelFile: item.reelFile,
                  })
                }}
                handleFileSelect={handleFileSelect}
                feedFile={item.feedFile}
                reelFile={item.reelFile}
                hasMediaPlacementError={hasMediaPlacementError}
                {...otherProps}
              />
            )
          })}
        </div>
      </>
    )
  }
  return null
}

MediaList.propTypes = {
  media: PropTypes.array,
  fileToReplace: PropTypes.object,
  onRemove: PropTypes.func,
  onRetry: PropTypes.func,
  readonly: PropTypes.bool,
  canRemove: PropTypes.bool,
  canReplace: PropTypes.bool,
  isMobileSize: PropTypes.bool,
  onAddFileToGroup: PropTypes.func,
  onReplaceFileInGroup: PropTypes.func,
  onRemoveGroup: PropTypes.func,
  onValidationError: PropTypes.func,
  hasMediaPlacementError: PropTypes.bool,
}

export default MediaList
